import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setDocumentSignature } from '../../../../../../_actions/questionnaire.actions'

export default function DocumentSignature() {
  const dispatch = useDispatch();

  const questionnaire = useSelector(state => state.questionnaire.current);

  const signatureExtension = questionnaire.extension.find(extension => {
    return extension.url === 'http://hl7.org/fhir/StructureDefinition/questionnaire-signatureRequired';
  });

  return <div className="form-group">
    <label><strong>Electronic Signature</strong></label>
    <div className="custom-control custom-switch">
      <input
        onChange={e => dispatch(setDocumentSignature(e.target.checked))}
        id="questionnaire-signature"
        checked={signatureExtension && signatureExtension.valueBoolean}
        value="note"
        type="checkbox"
        className="custom-control-input" />
      <label
        htmlFor="questionnaire-signature"
        className="custom-control-label">Require Document Signature</label>
    </div>
  </div>
}